module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_pp2_7042.640f571a.png";